import React from 'react';
import { Download, X, Save } from 'lucide-react';

// Banner shown when a preset is auto-loaded from a ?p=... URL.
// Lets the user choose to keep it (load only) or save it permanently.
export default function ShareImportBanner({ preset, onLoad, onSave, onDismiss }) {
  if (!preset) return null;

  const summary = preset.mode === 'song'
    ? `Song · ${preset.sections?.length || 0} sezioni`
    : `${preset.bpm} bpm · ${preset.signature} · ${preset.barsEnabled?.length || 1} bar`;

  return (
    <div
      data-testid="share-import-banner"
      className="bg-pink-500/10 border border-pink-400/40 rounded-2xl p-5 shadow-[0_0_30px_rgba(236,72,153,0.15)] flex items-start gap-4 flex-wrap"
    >
      <div className="bg-pink-400/20 p-2.5 rounded-lg shrink-0">
        <Download className="w-5 h-5 text-pink-300" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs uppercase tracking-[0.25em] text-pink-300/80">
          Preset condiviso ricevuto
        </div>
        <div className="font-bebas text-2xl tracking-wide text-white truncate">
          {preset.name || 'Preset senza nome'}
        </div>
        <div className="text-xs text-white/60 font-mono mt-0.5">{summary}</div>
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <button
          data-testid="import-load-btn"
          onClick={onLoad}
          className="bg-pink-400 hover:bg-pink-300 text-black text-xs font-medium px-4 py-2 rounded uppercase tracking-widest active:scale-95 transition-all"
        >
          Carica
        </button>
        <button
          data-testid="import-save-btn"
          onClick={onSave}
          className="border border-white/20 hover:border-white/40 text-white text-xs font-medium px-4 py-2 rounded uppercase tracking-widest active:scale-95 transition-all flex items-center gap-1.5"
        >
          <Save className="w-3.5 h-3.5" /> Carica & Salva
        </button>
        <button
          data-testid="import-dismiss-btn"
          onClick={onDismiss}
          className="text-white/50 hover:text-white p-1.5 rounded transition-all"
          aria-label="Chiudi"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
